<template>
  <div>
    <card>

      <label class="sr-only">Name of your configuration</label>
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button style="background-color: #33b5e5 !important;" block href="#"
                  v-b-toggle.collapse-1 variant="info">Want to know how I
          can Help, Click me!
        </b-button>
      </b-card-header>

      <b-collapse id="collapse-1" class="mt-2">
        <b-card>
          <p class="card-text">Influencers have a powerful influence on their followers is because
            their opinions are valued. Influencers are real people and often looked at as friends
            and audiences are looking for reality that they can emulate and buy into, as opposed to
            glamorous ads. YourSynchronicity make it easy for you to get the contact (email,
            website, phone number and more) of those
            influencers, by providing the tags that you are interested in, YsY will go and get the
            top posts related to that list of tag and as a best effort get their email or phone
            number</p>
        </b-card>
      </b-collapse>
      <b-input
        class="mb-2 mr-sm-2 mb-sm-0"
        v-model="configuration.nameConfiguration"
        placeholder="Name of your configuration"
      ></b-input>
      <p v-if="nameConfigurationChecked" style="color: red;font-size: 9px">Please enter the name of
        your configuration. (configuration name should be unique)</p>

      <!--Card Header-->
      <h3 slot="header" class="mb-0">Add new Instagram configuration</h3>
      <base-input label="Select the Action you want to execute">
        <el-select v-model="configuration.action" filterable
                   placeholder="Simple select">
          <el-option v-for="option in selectOptionsActions"
                     :key="option.label"
                     :label="option.label"
                     :value="option.value">
          </el-option>
        </el-select>
        <p v-if="actionChecked" style="color: red;font-size: 9px">Please choose on what
          Instagram you want to run this.</p>
      </base-input>
      <base-input label="Select on what Instagram you want to run this configuration.">
        <el-select v-model="configuration.email_instagram_to_run_on" filterable
                   placeholder="Simple select">
          <el-option v-for="option in selectOptionsEmailInstagram"
                     :key="option.label"
                     :label="option.label"
                     :value="option.value">
          </el-option>
        </el-select>
        <p v-if="emailInstagramChecked" style="color: red;font-size: 9px">Please choose on what
          Instagram you want to run this.</p>
      </base-input>
      <card>
        <tags-input v-model="configuration.tags" placeholder="Add new tag"
                    class="test"></tags-input>
        <p v-if="tagsChecked" style="color: red;font-size: 9px">Please enter at least one tag</p>
      </card>

      <b-button variant="primary" @click="addNewConfigurationInstagram">Save
        <b-spinner v-if="this.formAddNewConfigurationWaiting" small
                   label="Small Spinner"></b-spinner>
      </b-button>

    </card>

  </div>

</template>

<script>

    import 'sweetalert2/dist/sweetalert2.css';
    import TagsInput from '../Argon/Inputs/TagsInput'
    import {Select, Option} from 'element-ui'
    import {refreshIdToken} from '../../util/utilsYsy'

    export default {
        name: "addNewConfigurationInstagram",
        data() {
            return {
                selectOptionsActions: [
                    {
                        label: 'Get Influencers',
                        value: 'getInfluencers'
                    },
                    // {
                    //     label: 'Get test',
                    //     value: 'test'
                    // },

                ],

                selectOptionsEmailInstagram: [],
                actionChecked: false,
                emailInstagramChecked: false,
                tagsChecked: false,
                nameConfigurationChecked: false,
                formAddNewConfigurationWaiting: false,
                configuration:
                    {
                        email_instagram_to_run_on: '',
                        nameConfiguration: '',
                        action: '',
                        tags: [],
                    }
            }
                ;
        },
        components: {
            TagsInput,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        methods: {
            notifyVue(type) {
                if (type === 'success') {
                    this.$notify({
                        message:
                            '<b>Configuration added</b> - The dots started joining....',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type
                    });
                } else if (type === 'warning') {
                    this.$notify({
                        message:
                            '<b>Fail to add the configuration</b> - Please fill all the informations, before submit',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type
                    });
                } else if (type === 'danger') {
                    this.$notify({
                        message:
                            '<b>Fail to add the configuration</b> - Please try again later...',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type
                    });
                }
            },
            refreshIdToken,
            async addNewConfigurationInstagram() {
                if (this.configuration.nameConfiguration === '') {
                    console.log('please a name for your configuration');
                    this.nameConfigurationChecked = true;
                    return
                }
                if (this.configuration.email_instagram_to_run_on === '') {
                    console.log('please chose an email before proceed');
                    this.nameConfigurationChecked = false;
                    this.emailInstagramChecked = true;
                    return
                }
                if (this.configuration.action === '') {
                    console.log('please chose an action before proceed');
                    this.emailInstagramChecked = false;
                    this.actionChecked = true;
                    return
                }
                if (this.configuration.tags.length === 0) {
                    console.log('please chose at least one tag before proceed');
                    this.actionChecked = false;
                    this.tagsChecked = true;
                    return
                }

                this.formAddNewConfigurationWaiting = true;
                let payload = {
                    username: this.$store.getters.getUser,
                    email_instagram: this.configuration.email_instagram_to_run_on,
                    action: this.configuration.action,
                    configuration_name: this.configuration.nameConfiguration,
                    tags: this.configuration.tags,
                };

                const path = this.BACKEND_YSY + "/instagram/initState";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                await this.$http
                    .post(path, payload, {headers}).then(async res => {
                            console.log(res);
                            this.notifyVue('success')
                            this.resetForm()
                        }
                    ).catch(async error => {
                        const self = this;
                        if (error.response.status === 401) {
                            console.error('Unauthorized', error.response.data);
                            await this.refreshIdToken().then(function (result) {
                                console.log("res promise", result); // "Stuff worked!"
                                self.addNewConfigurationInstagram();
                            }, function (err) {
                                console.log("it broke", err); // Error: "It broke"
                                self.$router.push({name: 'login'});
                            });
                            return
                        }
                        this.notifyVue('danger')
                    });

            },
            resetForm() {
                this.emailInstagramChecked = false;
                this.tagsChecked = false;
                this.actionChecked = false;
                this.formAddNewConfigurationWaiting = false;
                this.configuration = {
                    email_instagram_to_run_on: '',
                    nameConfiguration: '',
                    action: '',
                    tags: [],
                }
            }
        },
        created() {
            console.log('this.$store.getters.getHaveAccountInstagram', this.$store.getters.getHaveAccountInstagram)
            if (this.$store.getters.getHaveAccountInstagram) {
                let emailsInstagram = this.$store.getters.getEmailInstagram;
                var self = this;
                emailsInstagram.forEach(function (email) {
                    self.selectOptionsEmailInstagram.push({
                        label: email,
                        value: email
                    })
                })
            }
        },
    }
</script>

<style>

</style>
